<div class="container">
  <mat-card>
    <form [formGroup]="notificationConfigurationForm" (ngSubmit)="submit()">
      <mat-card-content>
        <div class="layout-column">
          <mat-form-field>
            <mat-label>{{ 'labels.inputs.Server Key' | translate }}</mat-label>
            <input matInput required formControlName="server_key" />
            @if (notificationConfigurationForm.controls.server_key.hasError('required')) {
              <mat-error>
                {{ 'labels.inputs.Server Key' | translate }} {{ 'labels.commons.is' | translate }}
                <strong>{{ 'labels.commons.required' | translate }}</strong>
              </mat-error>
            }
          </mat-form-field>

          <mat-form-field>
            <mat-label>{{ 'labels.inputs.GCM End Point' | translate }}</mat-label>
            <input matInput required formControlName="gcm_end_point" />
            @if (notificationConfigurationForm.controls.gcm_end_point.hasError('required')) {
              <mat-error>
                {{ 'labels.inputs.GCM End Point' | translate }} {{ 'labels.commons.is' | translate }}
                <strong>{{ 'labels.commons.required' | translate }}</strong>
              </mat-error>
            }
          </mat-form-field>

          <mat-form-field>
            <mat-label>{{ 'labels.inputs.FCM End Point' | translate }}</mat-label>
            <input matInput required formControlName="fcm_end_point" />
            @if (notificationConfigurationForm.controls.fcm_end_point.hasError('required')) {
              <mat-error>
                {{ 'labels.inputs.FCM End Point' | translate }} {{ 'labels.commons.is' | translate }}
                <strong>{{ 'labels.commons.required' | translate }}</strong>
              </mat-error>
            }
          </mat-form-field>
        </div>
      </mat-card-content>

      <mat-card-actions class="layout-row align-center gap-5px responsive-column">
        <button type="button" mat-raised-button [routerLink]="['../']">
          {{ 'labels.buttons.Cancel' | translate }}
        </button>
        <button
          mat-raised-button
          color="primary"
          [disabled]="!notificationConfigurationForm.valid || notificationConfigurationForm.pristine"
        >
          {{ 'labels.buttons.Submit' | translate }}
        </button>
      </mat-card-actions>
    </form>
  </mat-card>
</div>
